<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
          <div class="col">
            <b-dropdown :text="yearDropdownText" variant="outline-secondary" size="sm" class="m-md-2">
              <b-dropdown-item v-for="yearCategory in yearCategories" :key="yearCategory.code" @click="changeYearCategory(yearCategory.code, yearCategory.label)">{{ yearCategory.label }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="col text-right">
            <b-button 
              variant="outline-secondary"
              size="sm"
              v-b-popover.hover="'Summary of risk ratings associated with different asset components.'" >
              <i class="fas fa-question-circle"></i>
            </b-button>
          </div>
      </div>
      <DoughnutChart
        v-if="dataLoaded"
        :key="seletedYearCategory"
        :chartData="baseChartData"
        :options="options"
        :height="240"
        :style="chartCustomStyles"></DoughnutChart>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import DoughnutChart from "./DoughnutChart.vue"
export default {
  name: "AssetElementsMediumToExtremeChart",
  components: {
      DoughnutChart
  },
  props: {
    projCRADetails: Array,
    inputProjectCode: String,
    title: String
  },
  data() {
    return {
      flag: 0,
      dataLoaded: false,
      yearDropdownText: "2030",
      seletedYearCategory: "riskRatingNFCode",
      baseChartData: {
        datasets:[
          {
            fill: true,
            label: "",
            backgroundColor: [
              "#f66d9b",
              "#9561e2",
              "#6574cd",
              "#e3342f",
              "#f6993f",
              "#ffed4a",
              "#38c172",
              "#4dc0b5",
              "#3490dc",
              "#F6E9F8",
              "#F8354F",
              "#261F50",
              "#A6CACE",
              "#B0B87F"
            ],
            data: [1,1,1]
            // data: [0,0,0]
          }
        ],
        labels: [
        'Pavements',
        'Bridges and Viaducts',
        'Drainage Structures',
        'Retaining Walls',
        'Road furniture',
        'Noise Walls',
        'Control systems',
        'Street and Road Lighting',
        'Utilities',
        'Landscaping',
        'Embankments',
        'Construction Site',
        'Buildings',
        'Operational Objectives'
        ],
      },
      options: {
        title: {
          text: "Risks proportion by time and rating",
          display: true,
          fontFamily: "Segoe UI",
          fontSize: 20
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontStyle: 'bold',
            fontFamily: 'Segoe UI'
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                return previousValue + currentValue;
              });
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = Math.floor(((currentValue/total) * 100)+0.5);

              return data['labels'][tooltipItem['index']] + ":" + percentage + "%";
            }
          }
        },
        responsive: true,
        // maintainAspectRatio: false
      },
      yearCategories: [
        {
          code: "riskRatingNFCode",
          label: "2030"
        },
        {
          code: "riskRatingMFCode",
          label: "2050"
        },
        {
          code: "riskRatingFFCode",
          label: "2090"
        },
      ]
    }
  },
  computed: {
    chartCustomStyles () {
      return {
        height: `89% !important`,
        position: 'relative'
      }
    }
  },
  methods: {
    changeYearCategory: function(riskYearCode, riskYear){
      console.log(riskYearCode)
      this.seletedYearCategory = riskYearCode
      this.yearDropdownText = riskYear
      this.dataLoaded = false;
      var medium = (this.projCRADetails.filter(obj => obj[riskYearCode] == "medium")).length;
      var high = (this.projCRADetails.filter(obj => obj[riskYearCode] == "high")).length;
      var veryHigh = (this.projCRADetails.filter(obj => obj[riskYearCode] == "very_high")).length;

      var pavements = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "pavements" &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var bridges_and_viaducts = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "bridges_and_viaducts"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var drainage = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "drainage"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var retaining_walls = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "retaining_walls"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var road_furniture = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "road_furniture"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var noise_walls = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "noise_walls"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var control_systems = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "control_systems"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var street_road_lighting = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "street_road_lighting"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
      var utilities = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "utilities"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;

     var landscaping = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "landscaping"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
    var embankments = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "embankments"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;

     var construction = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "construction"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;
     var buildings = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "buildings"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;

     var operations = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "operations"  &&
                      (obj[riskYearCode] == "medium" || 
                      obj[riskYearCode] == "high" ||
                      obj[riskYearCode] == "very_high"
                      )
                       )).length;

      this.baseChartData.datasets[0].data = [
        pavements,
        bridges_and_viaducts,
        drainage,
        retaining_walls,
        road_furniture,
        noise_walls,
        control_systems,
        street_road_lighting,
        utilities,
        landscaping,
        embankments,
        construction,
        buildings,
        operations
      ]
      console.log(this.baseChartData.datasets[0].data)
      this.dataLoaded = true;
    },
    setupData: function() {
      var medium = (this.projCRADetails.filter(obj => obj[this.seletedYearCategory] == "medium")).length;
      var high = (this.projCRADetails.filter(obj => obj[this.seletedYearCategory] == "high")).length;
      var veryHigh = (this.projCRADetails.filter(obj => obj[this.seletedYearCategory] == "very_high")).length;

      var pavements = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "pavements" &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var bridges_and_viaducts = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "bridges_and_viaducts"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var drainage = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "drainage"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var retaining_walls = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "retaining_walls"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var road_furniture = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "road_furniture"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var noise_walls = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "noise_walls"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var control_systems = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "control_systems"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var street_road_lighting = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "street_road_lighting"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
      var utilities = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "utilities"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;

     var landscaping = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "landscaping"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
    var embankments = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "embankments"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;

     var construction = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "construction"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;
     var buildings = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "buildings"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;

     var operations = (this.projCRADetails.filter(obj => obj.primaryAssetTypeCode == "operations"  &&
                      (obj[this.seletedYearCategory] == "medium" || 
                      obj[this.seletedYearCategory] == "high" ||
                      obj[this.seletedYearCategory] == "very_high"
                      )
                       )).length;

      this.baseChartData.datasets[0].data = [
        pavements,
        bridges_and_viaducts,
        drainage,
        retaining_walls,
        road_furniture,
        noise_walls,
        control_systems,
        street_road_lighting,
        utilities,
        landscaping,
        embankments,
        construction,
        buildings,
        operations
      ]


      this.options.title.text = this.title
      this.dataLoaded = true;
    },
  },
  
  beforeMount() {
    this.setupData()
    // this.baseChartData.labels.forEach((item,index)=>{
    //   this.baseChartData.labels[index] = item + ": " + (this.projCRADetails.filter(obj => obj.riskRatingNFCode == item)).length
    // })
  }
}
</script>

<style lang="css" scoped>
</style>
